module.exports = __webpack_public_path__ + "img/ser.a5007ee0.png";